var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2rem",
    height: "1.125rem",
    viewBox: "0 0 32 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DA291C",
    fillRule: "evenodd",
    points: "29.225 0 16.031 13.617 2.837 0 .017 0 0 .018 0 2.918 14.615 17.999 17.447 17.999 32.001 2.981 32.001 0",
    transform: "rotate(180 16 9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRegular);
export default __webpack_public_path__ + "static/media/arrowUpRegular.14b7f9f0c23ffca9811e22b9d2c32d90.svg";
export { ForwardRef as ReactComponent };